import React from 'react';
import PropTypes from 'prop-types';
import CTA from '../common/CTA/CTA';
import styles from './Hero.module.scss';
class Hero extends React.Component {
  render () {
    const { data } = this.props;
    return (
      <section className={`hero ${styles.hero}`}>
        <div className={`wrapper ${styles.wrapper}`}>
          <div
            className={`
              primaryArea ${styles.primaryArea}
              ${data.primaryArea.textTheme === "light" ?
                styles.theme_light : styles.theme_dark
              }
            `}>
            <div className={`content ${styles.content}`}>
              <div className={`flex-row ${styles.noGutter}`}>
                  <div className="col-lg-6 col-md-6">
                    <span className={`eyebrow ${styles.eyebrow}`}>
                      {data.primaryArea.eyebrow}
                    </span>
                    <h1 className={`heading-one ${styles["heading-one"]}`}>
                      {data.primaryArea.heading}
                    </h1>
                    <div className={`copy ${styles.copy}`}>
                      <p>{data.primaryArea.copy1}</p>
                      <p>{data.primaryArea.copy2}</p>                
                    </div>
                  </div>   
                </div>
            </div>
          </div>

          {/* Secondary Area */}
          <div className={`
            secondaryArea ${styles.secondaryArea}
            ${data.secondaryArea.textTheme === "light" ?
              styles.theme_light : styles.theme_dark} `}>
            <div className={`${styles.container}`}>
              <div className={`flex-row ${styles.noGutter}`}>
                <div className="col-sm-12 col-lg-6 col-md-6">
                  <div className={`content secondaryWrapper ${styles.content}`}>
                    <div className={`tiers ${styles.tiers}`}>
                      <h3 className={`heading ${styles.heading}`}>
                        {data.secondaryArea.copy}
                      </h3>

                      <CTA data={data.secondaryArea.cta} />
                    </div>
                  </div>
                </div>
                <div className="col-sm-12 col-lg-6 col-md-6">
                  <div className={`content secondaryWrapper ${styles.content}`}>              
                    <div className={`download ${styles.download}`}>
                    <h3 className={`heading ${styles.heading}`}>
                      {data.secondaryArea.downloadSection.heading}
                    </h3>

                    <p>{data.secondaryArea.downloadSection.copy}</p>

                    <div className={`badges ${styles.badges}`}>
                      {
                        data.secondaryArea.downloadSection.apps.map((current, index) => (
                          <div key={index} className={`badge ${styles.badge}`}>
                            <a
                              href={current.url}
                              target="_blank"
                              id={current.id}
                              className={styles[current.icon]}
                              rel="noopener noreferrer"
                            >
                              <span>{current.altText}</span>
                            </a>
                          </div>
                        ))
                      }
                    </div>

                    <p className={`discalimer ${styles.disclaimer}`}>{data.secondaryArea.downloadSection.disclaimer}</p>
                  </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>      
      </section>
    )
  }
};

Hero.propTypes = {
  data: PropTypes.object
};

Hero.defaultProps = {
  data: {}
};

export default Hero;
